<ng-container *ngFor="let seccion of notifications">
  <mat-card class="notification-section">
    <mat-card-header>
      <h4 class="error">
        <span style="font-weight: 700;">{{seccion.titulo}}</span>
      </h4>
    </mat-card-header>
    <mat-card-content>
      <div class="mat-list mat-nav-list custom-list">
        <ng-container *ngFor="let item of seccion.items">
          <div class="mat-list-item">
            <notificacion [notificationItem]="item"></notificacion>
          </div>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>